import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledInfoContainer = styled.div`
  position: absolute;
  left: 0;
  top: var(--header-size);

  ${themeMedia.mobile`
    p {
      line-height: 1.09em !important;
    }
  `};

  ${themeMedia.desktop`
    position: sticky;
    z-index: 2;
    margin-top: -4em;
    margin-bottom: 2em;
  `};
`

export const StyledSpacing = styled.div`
  height: 4em;

  ${themeMedia.desktop`
    display: none;
  `};
`
